import { CinemaAction } from "../types/entities/action"

export function normalizeCinemaActions(data: unknown): CinemaAction[] {
    if (!Array.isArray(data)) return []

    return data
        .filter((item): item is CinemaAction => {
            if (!item || typeof item !== "object") return false
            const action = item as CinemaAction
            return (
                typeof action.id === "number" &&
                typeof action.title === "string" &&
                action.title.length > 0 &&
                typeof action.image === "string" &&
                action.image.length > 0 &&
                action.show_on_site !== false
            )
        })
        .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0) || a.id - b.id)
}

/** Простая очистка HTML от script/iframe и on*-атрибутов (callout div/class сохраняются) */
export function sanitizeActionHtml(html: string): string {
    if (!html) return ""
    return html
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
        .replace(/<iframe[\s\S]*?>[\s\S]*?<\/iframe>/gi, "")
        .replace(/\son\w+\s*=\s*(['"]).*?\1/gi, "")
        .replace(/\son\w+\s*=\s*[^\s>]+/gi, "")
        .replace(/javascript:/gi, "")
}
